export const FETCH_TICKETS_OPENED_START = 'FETCH_TICKETS_OPENED_START';
export const FETCH_TICKETS_OPENED_SUCCESS = 'FETCH_TICKETS_OPENED_SUCCESS';
export const FETCH_TICKETS_OPENED_FAILURE = 'FETCH_TICKETS_OPENED_FAILURE';

export const FETCH_TICKETS_CLOSED_START = 'FETCH_TICKETS_CLOSED_START';
export const FETCH_TICKETS_CLOSED_SUCCESS = 'FETCH_TICKETS_CLOSED_SUCCESS';
export const FETCH_TICKETS_CLOSED_FAILURE = 'FETCH_TICKETS_CLOSED_FAILURE';

export const FETCH_TICKET_DETAILS_START = 'FETCH_TICKET_DETAILS_START';
export const FETCH_TICKET_DETAILS_SUCCESS = 'FETCH_TICKET_DETAILS_SUCCESS';
export const FETCH_TICKET_DETAILS_FAILURE = 'FETCH_TICKET_DETAILS_FAILURE';

export const ADD_TICKET_MESSAGE_START = 'ADD_TICKET_MESSAGE_START';
export const ADD_TICKET_MESSAGE_SUCCESS = 'ADD_TICKET_MESSAGE_SUCCESS';
export const ADD_TICKET_MESSAGE_FAILURE = 'ADD_TICKET_MESSAGE_FAILURE';

export const CREATE_TICKET_START = 'CREATE_TICKET_START';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const CREATE_TICKET_FAILURE = 'CREATE_TICKET_FAILURE';

export const CLOSE_TICKET_START = 'CLOSE_TICKET_START';
export const CLOSE_TICKET_SUCCESS = 'CLOSE_TICKET_SUCCESS';
export const CLOSE_TICKET_FAILURE = 'CLOSE_TICKET_FAILURE';

export const FETCH_NEW_TICKETS_START = 'FETCH_NEW_TICKETS_START';
export const FETCH_NEW_TICKETS_SUCCESS = 'FETCH_NEW_TICKETS_SUCCESS';
export const FETCH_NEW_TICKETS_FAILURE = 'FETCH_NEW_TICKETS_FAILURE';
